module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Light-7d7616d6b41a6eebff821b964d94edf5.ttf";